import gql from 'graphql-tag'

const deleteTeam = gql`
  mutation deleteTeam($team_id: Float!, $workspace_id: Float!) {
    deleteTeam(team_id: $team_id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`

export default deleteTeam
